define('ordersSampleView',[
  'app',
  'module',
  'marionette',
  'underscore',
  'template!ordersSampleView'
], function (
  App,
  Module,
  Marionette,
  _,
  Tpl
) {
  'use strict';

  Module.exports = Marionette.LayoutView.extend({
    template: Tpl,
    className: 'orders-sample-view',

    ui: {
      sample: '.sample'
    },

    events: {
      'click .sample': 'onClickSample'
    },

    modelEvents: {
      'change:sample': 'render'
    },

    onRender: function () {
      if (this.model.get('sample')) {
        this.ui.sample.addClass('active');
        this.ui.sample.attr('title', _.i18n ? _.i18n('common.sample') : 'Enabled');
      } else {
        this.ui.sample.removeClass('active');
        this.ui.sample.attr('title', _.i18n ? _.i18n('common.notSample') : 'Disabled');
      }
    },

    onClickSample: function (e) {
      e.stopPropagation();
      e.preventDefault();
      var current = !!this.model.get('sample');
      this.model.updateSample(!current).done(_.bind(function () {
        this.model.fetch();
      }, this));
    }
  });
});

